/* eslint-disable new-cap */
import { Downgraded, useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import { getStatisticsDispatchByConnectedDevicesXStatusPieChart } from '~/features/Dispatch/services'
import PieChartMui from '~/components/PieChartMui'
import useSystemState from '~/features/System/stores/SystemState'
import { addTotals } from '~/utils/format'

export default function DispatchByConnectedDevicesXStatusPieChart({
  operationId,
  initialDate,
  endDate,
  refresh,
  loading,
}) {
  const data = useHookstate([])
  const { getDeviceStatusColors } = useSystemState()


  useEffect(() => {
    loading.set(true)
    getStatisticsDispatchByConnectedDevicesXStatusPieChart({
      operationId: operationId,
      initialDate: initialDate,
      endDate: endDate,
    })
      .then((response) => {
        const result = response.map((responseData, index) => ({
          id: index,
          label: responseData.name,
          value: responseData.total,
          total: responseData.total,
          color:
            responseData.name == 'EM MISSÃO'
              ? '#004c8e'
              : getDeviceStatusColors(responseData.id).main,
        }))
        return data.set(result)
      })
      .finally(() => {
        loading.set(false)
      })
  }, [refresh])

  return (
    <PieChartMui
      data={data.attach(Downgraded).get()}
      title={'Device Connected x Status*'}
      info="* Excluindo dispositivos desconectados"
      subtitle={`Total de Conectados x Status: ${addTotals(data.attach(Downgraded).get())}`}
      typeTotal={'Status'}
      showPercent
    />
  )
}
